import React from 'react';
import {
  FormGroup,
  InputGroup,
  FormControl,
  Button
} from 'react-bootstrap';


// stateless functional component definition in ES6 way.
const LoginUd = props => {
  return (
    <div>
      <FormGroup>
        <InputGroup>
          <FormControl type="text"
            placeholder="帳號"
            value={props.email}
            onChange={props.handlers.handleEmailKeyin}
            id="fcEm" />
        </InputGroup>
      </FormGroup>

      <FormGroup>
        <InputGroup>
          <FormControl type={props.showPassword ? "text" : "password"}
            value={props.password}
            onChange={props.handlers.handlePasswordKeyin}
            placeholder="密碼"
            id="fcPw" />
        </InputGroup>
      </FormGroup>
      <FormControl type="text"
        value={props.capcha}
        onChange={props.handlers.handleCapchaKeyin}
        placeholder="驗證碼"
        id="inpCapcha" />
      <img id='img-capcha' src={props.capchaImgSrc} alt="capchaImg" />
      <span id='img-rem-email'>
        <img src={`/imgs/ic_checkbox_${props.remEmail ? 'on' : 'off'}_nor.svg`} onClick={props.handlers.handleRemEmail} alt="checkboxImg" />
        <span>記住我的帳號</span>
      </span>
      <img id='img-toggle-pw-visible' src={`/imgs/ic_visibility_${props.showPassword ? 'on' : 'off'}_nor.svg`} onClick={props.handlers.handlePassword} alt="eyeImg" />
      <span id="span-reset-capcha" onClick={props.resetCapcha}>重取驗證碼</span>
      <Button bsStyle="info"
        bsSize="large" block
        onClick={props.handlers.handleSubmit}
        disabled={props.disabled}
        id="btnLogin"
      >登入</Button>
    </div>
  );
}

export default LoginUd;



// WEBPACK FOOTER //
// ./src/skyfamily/routes/login/LoginUd.jsx